module.exports = __webpack_public_path__ + "img/circle-left.ad948d39.svg";